export const maxChaptersPerBook = {
  Genesis: {
    weight: 1, //Torah
    chapters: 50,
    verses: [
      31, 25, 24, 26, 32, 22, 24, 22, 29, 32, 32, 20, 18, 24, 21, 16, 27, 33,
      38, 18, 34, 24, 20, 67, 34, 35, 46, 22, 35, 43, 55, 32, 20, 31, 29, 43,
      36, 30, 23, 23, 57, 38, 34, 34, 28, 34, 31, 22, 33, 26,
    ],
    breaks: {
      2: [3, 14],
      9: [17],
      10: [5, 20],
      11: [9],
      12: [9],
      18: [15],
      19: [29],
      21: [7, 21],
      22: [19],
      25: [11, 18],
      27: [40],
      28: [9],
      29: [13, 30],
      30: [24],
      31: [21],
      32: [21],
      35: [15],
      36: [30],
      37: [11],
      41: [40],
      47: [12],
      49: [28],
      50: [14, 21],
    },
  },

  Exodus: {
    weight: 1, //Torah
    chapters: 40,
    verses: [
      22, 25, 22, 31, 23, 30, 25, 32, 35, 29, 10, 51, 22, 31, 27, 36, 16, 27,
      25, 26, 36, 31, 33, 18, 40, 37, 21, 43, 46, 38, 18, 35, 23, 35, 35, 38,
      29, 31, 43, 38,
    ],
    breaks: {
      2: [10],
      4: [18],
      6: [12],
      7: [7, 13],
      8: [15, 19],
      9: [12],
      10: [21],
      12: [42],
      13: [16],
      15: [21],
      17: [7],
      20: [21],
      21: [11],
      22: [15],
      23: [9, 13, 20],
      25: [9, 22, 30],
      27: [8, 19],
      28: [5, 14, 30],
      30: [10, 16, 21, 33],
      31: [11],
      33: [6, 11],
      34: [28],
      35: [3, 29],
      36: [7],
      37: [9, 16, 24],
      38: [7, 21],
      39: [7, 21, 31],
      40: [33],
    },
  },

  Leviticus: {
    weight: 1, //Torah
    chapters: 27,
    verses: [
      17, 16, 17, 35, 19, 30, 38, 36, 24, 20, 47, 8, 59, 57, 33, 34, 16, 30,
      37, 27, 24, 33, 44, 23, 55, 46, 34,
    ],
    breaks: {
      5: [13],
      6: [7, 13, 23],
      7: [10, 20, 27],
      13: [46],
      14: [32],
      22: [16],
      23: [8, 14, 22, 25, 32],
      24: [9],
      25: [7],
      26: [13],
    },
  },

  Numbers: {
    weight: 1, //Torah
    chapters: 36,
    verses: [
      54, 34, 51, 49, 31, 27, 89, 26, 23, 36, 35, 16, 33, 45, 41, 50, 13, 32,
      22, 29, 35, 41, 30, 25, 18, 65, 23, 31, 40, 16, 54, 42, 56, 29, 34, 13,
    ],
    breaks: {
      4: [20, 28, 33],
      5: [4, 10],
      6: [21],
      9: [14],
      10: [10],
      13: [25],
      15: [21, 31, 36],
      20: [13, 21],
      22: [20],
      23: [12],
      24: [14, 19],
      27: [11],
      28: [8, 15, 25],
      29: [6, 11],
      31: [24],
    },
  },

  Deuteronomy: {
    weight: 1, //Torah
    chapters: 34,
    verses: [
      46, 37, 29, 49, 33, 25, 26, 20, 29, 22, 32, 32, 18, 29, 23, 22, 20, 22,
      21, 20, 23, 30, 25, 22, 19, 19, 26, 68, 29, 20, 30, 52, 29, 12,
    ],
    breaks: {
      1: [8, 18],
      2: [23],
      3: [11, 20],
      4: [14, 31, 43],
      9: [6],
      10: [11],
      15: [11, 18],
      16: [8],
      17: [7, 13],
      18: [8],
      19: [14],
      21: [9],
      22: [12],
      23: [8, 14],
      27: [8],
      28: [14],
      30: [10],
      32: [47],
    }},

    Joshua: {
      weight: 2, //Historical
      chapters: 24,
      verses: [
        18, 24, 17, 24, 15, 27, 26, 35, 27, 43, 23, 24, 33, 15, 63, 10, 18, 28,
        51, 9, 45, 34, 16, 33,
      ],
      breaks: {
        5: [12],
        8: [29],
        10: [15, 28],
        18: [10],
        19: [9, 16, 31, 39],
        24: [27],
      },
    },

    Judges: {
      weight: 2, //Historical
      chapters: 21,
      verses: [
        36, 23, 31, 24, 31, 40, 25, 35, 57, 18, 40, 15, 25, 20, 20, 31, 13, 31,
        30, 48, 25,
      ],
      breaks: { 2: [5], 3: [11], 8: [21, 27], 12: [7], 16: [22] },
    },

    Ruth: {
      weight: 2, //Historical
      chapters: 4,
      verses: [
        22, 23, 18, 22,
      ],
    },

    "1 Samuel": {
      weight: 2, //Historical
      chapters: 31,
      verses: [
        28, 36, 21, 22, 12, 21, 17, 22, 27, 27, 15, 25, 23, 52, 35, 23, 58, 30,
        24, 42, 15, 23, 29, 22, 44, 25, 12, 25, 11, 31, 13,
      ],
      breaks: {
        1: [20],
        2: [11, 26],
        4: [11],
        10: [8],
        13: [15],
        14: [14, 23],
        16: [13],
        21: [9],
        23: [6],
      }
    },

    "2 Samuel": {
      weight: 2, //Historical
      chapters: 24,
      verses: [
        27, 32, 39, 12, 25, 23, 29, 18, 13, 19, 27, 31, 39, 33, 37, 23, 29, 33,
        43, 26, 22, 51, 39, 25,
      ],
      breaks: {
        1: [16],
        2: [7],
        3: [21],
        5: [16],
        7: [17],
        13: [22],
        15: [12],
        16: [14],
        18: [18],
        19: [8],
        21: [14],
        23: [7],
        24: [17],
      },
    },

    "1 Kings": {
      weight: 2, //Historical
      chapters: 22,
      verses: [
        53, 46, 28, 34, 18, 38, 51, 66, 28, 29, 43, 33, 34, 31, 34, 34, 24, 46,
        21, 43, 29, 53,
      ],
      breaks: {
        1: [27],
        2: [12],
        3: [15],
        4: [19, 28],
        7: [12],
        8: [21, 61],
        9: [9],
        10: [13],
        11: [13, 25],
        12: [24],
        14: [20],
        15: [8, 24],
        16: [7, 14, 20, 28],
        17: [6],
        18: [15],
        19: [9],
        20: [12, 34],
        22: [28, 40],
      },
    },

    "2 Kings": {
      weight: 2, //Historical
      chapters: 25,
      verses: [
        18, 25, 27, 44, 27, 33, 20, 29, 37, 36, 21, 21, 25, 29, 38, 20, 41, 37,
        37, 21, 26, 20, 37, 20, 30,
      ],
      breaks: {
        2: [19],
        4: [7, 37],
        6: [7, 23],
        8: [6, 15, 24],
        9: [13, 29],
        10: [17],
        13: [9],
        14: [22],
        15: [7, 13, 17, 22, 32],
        17: [6, 23],
        18: [16],
        19: [13, 19],
        20: [11],
        21: [18],
        23: [30],
        24: [7],
      },
    },
    "1 Chronicles": {
      weight: 2, //Historical
      chapters: 29,
      verses: [
        54, 55, 24, 43, 26, 81, 40, 40, 44, 14, 47, 40, 14, 17, 29, 43, 27, 17,
        19, 8, 30, 19, 32, 31, 31, 32, 34, 21, 30,
      ],
      breaks: {
        1: [7, 16, 31, 37],
        2: [9, 17, 24, 41],
        3: [9, 16],
        4: [23],
        5: [10, 22],
        6: [30],
        7: [13, 19, 29],
        9: [34],
        11: [9],
        12: [22],
        14: [7],
        16: [6],
        17: [15],
        23: [6, 11, 20],
        24: [19],
        26: [19],
        27: [15, 24],
        29: [9, 20, 25],
      },
    },
    "2 Chronicles": {
      weight: 2, //Historical
      chapters: 36,
      verses: [
        17, 18, 17, 22, 14, 42, 22, 18, 31, 19, 23, 16, 22, 15, 19, 14, 19, 34,
        11, 37, 20, 12, 21, 27, 28, 23, 9, 27, 36, 27, 21, 33, 25, 33, 27, 23,
      ],
      breaks: {
        6: [12],
        7: [10],
        9: [12, 28],
        11: [17],
        18: [27],
        20: [30],
        24: [16],
        32: [23],
        33: [20],
        34: [13],
        35: [20],
        36: [8, 14],
      },
    },

    Ezra: {
      weight: 2, //Historical
      chapters: 10,
      verses: [
        11, 70, 13, 24, 17, 22, 28, 36, 15, 44,
      ],
      breaks: { 6: [12, 18], 7: [10], 8: [14], 10: [17] },
    },

    Nehemiah: {
      weight: 2, //Historical
      chapters: 13,
      verses: [
        11, 20, 32, 23, 19, 19, 73, 18, 38, 39, 36, 47, 31,
      ],
      breaks: { 2: [10], 12: [26] },
    },

    Esther: {
      weight: 2, //Historical
      chapters: 10,
      verses: [
        22, 23, 15, 17, 14, 14, 10, 17, 32, 3,
      ],
      breaks: { 2: [18], 5: [8], 9: [17] },
    },

    Job: {
      weight: 2, //Historical
      chapters: 42,
      verses: [
        22, 13, 26, 21, 27, 30, 21, 22, 35, 22, 20, 25, 28, 22, 35, 22, 16, 21,
        29, 29, 34, 30, 17, 25, 6, 14, 23, 28, 25, 31, 40, 22, 33, 37, 16, 33,
        24, 41, 30, 24, 34, 17,
      ],
      breaks: {},
    },
    Psalms: {
      weight: 3, //Wisdom
      chapters: 150,
      verses: [
        6, 12, 8, 8, 12, 10, 17, 9, 20, 18, 7, 8, 6, 7, 5, 11, 15, 50,
        14, 9, 13, 31, 6, 10, 22, 12, 14, 9, 11, 13, 25, 11, 22, 23, 28, 13,
        40, 22, 13, 17, 13, 11, 5, 26, 17, 11, 9, 14, 20, 23, 19, 9, 6, 7,
        23, 13, 11, 11, 17, 12, 8, 12, 11, 10, 13, 20, 7, 35, 36, 5, 24, 20,
        28, 23, 10, 12, 20, 72, 13, 19, 16, 8, 18, 12, 13, 17, 7, 18, 52, 17,
        16, 15, 5, 23, 11, 13, 12, 9, 9, 5, 8, 28, 22, 35, 45, 48, 43, 13,
        31, 7, 10, 10, 9, 8, 18, 19, 2, 29, 176, 7, 8, 9, 4, 8, 5, 6,
        5, 6, 8, 8, 3, 18, 3, 3, 21, 26, 9, 8, 24, 14, 10, 8, 12, 15,
        21, 10, 20, 14, 9, 6,
      ],
    },

    Proverbs: {
      weight: 3, //Wisdom
      chapters: 31,
      verses: [
        33, 22, 35, 27, 23, 35, 27, 36, 18, 32, 31, 28, 25, 35, 33, 33, 28, 24,
        29, 30, 31, 29, 35, 34, 28, 28, 27, 28, 27, 33, 31,
      ],
      breaks: { 1: [7, 19], 6: [19], 24: [22], 31: [9] },
    },

    Ecclesiastes: {
      weight: 3, //Wisdom
      chapters: 12,
      verses: [
        18, 26, 22, 16, 20, 12, 29, 17, 18, 20, 10, 14,
      ],
      breaks: { 1: [11], 2: [11, 16], 5: [7], 9: [12], 11: [6], 12: [8] },
    },
    "Song of Songs": {
      weight: 3, //Wisdom
      chapters: 8,
      verses: [
        17, 17, 11, 16, 16, 13, 13, 14,
      ],
    },

    Isaiah: {
      weight: 4, //Major Prophets
      chapters: 66,
      verses: [
        31, 22, 26, 6, 30, 13, 25, 22, 21, 34, 16, 6, 22, 32, 9, 14, 14, 7,
        25, 6, 17, 25, 18, 23, 12, 21, 13, 29, 24, 33, 9, 20, 24, 17, 10, 22,
        38, 22, 8, 31, 29, 25, 28, 28, 25, 13, 15, 22, 26, 11, 23, 15, 12, 17,
        13, 12, 21, 14, 21, 22, 11, 12, 19, 12, 25, 24,
      ],
      breaks: {
        5: [7],
        9: [7],
        10: [19],
        14: [23],
        37: [13, 20],
        42: [9, 17],
        43: [13],
        44: [23],
        49: [7],
        52: [12],
        57: [13],
        63: [6],
        65: [16],
      },
    },

    Jeremiah: {
      weight: 4, //Major Prophets
      chapters: 52,
      verses: [
        19, 37, 25, 31, 31, 30, 34, 22, 26, 25, 23, 17, 27, 22, 21, 21, 27, 23,
        15, 18, 14, 30, 40, 10, 38, 24, 22, 17, 32, 24, 40, 44, 26, 22, 19, 32,
        21, 28, 18, 16, 18, 22, 13, 30, 5, 28, 7, 47, 39, 46, 64, 34,
      ],
      breaks: {
        7: [29],
        10: [16, 22],
        11: [17],
        13: [14],
        17: [18],
        20: [6],
        23: [8],
        25: [14],
        29: [23],
        34: [7],
        38: [13],
        40: [6],
        49: [6, 22, 27, 33],
      },
    },

    Lamentations: {
      weight: 4, //Major Prophets
      chapters: 5,
      verses: [
        22, 22, 66, 22, 22,
      ],
    },

    Ezekiel: {
      weight: 4, //Major Prophets
      chapters: 48,
      verses: [
        28, 10, 27, 17, 17, 14, 27, 18, 11, 22, 25, 28, 23, 23, 8, 63, 24, 32,
        14, 49, 32, 31, 49, 27, 17, 21, 36, 26, 21, 26, 18, 32, 33, 31, 15, 38,
        28, 23, 29, 49, 26, 20, 27, 31, 25, 24, 23, 35,
      ],
      breaks: {
        3: [15],
        11: [15],
        14: [11],
        20: [29],
        24: [14],
        25: [7],
        33: [20],
        37: [14],
        40: [16, 23, 38],
        43: [12],
        45: [12],
        47: [12],
      },
    },

    Daniel: {
      weight: 4, //Major Prophets
      chapters: 12,
      verses: [
        21, 49, 30, 37, 31, 28, 28, 27, 27, 21, 45, 13,
      ],
      breaks: { 2: [23], 4: [18, 27], 7: [14], 8: [14], 9: [20], 11: [35] },
    },
    Hosea: {
      weight: 5, //Minor Prophets
      chapters: 14,
      verses: [
        11, 23, 5, 19, 15, 11, 16, 14, 17, 15, 12, 14, 16, 9,
      ],
    },

    Joel: {
      weight: 5, //Minor Prophets
      chapters: 3,
      verses: [
        20, 32, 21,
      ],
      breaks: { 1: [12], 2: [11, 27], 3: [16] },
    },

    Amos: {
      weight: 5, //Minor Prophets
      chapters: 9,
      verses: [
        15, 16, 15, 13, 27, 14, 17, 14, 15,
      ],
      breaks: { 5: [17], 7: [9], 9: [10] },
    },
    Obadiah: {
      weight: 5, //Minor Prophets
      chapters: 1,
      verses: [
        21,
      ],
    },

    Jonah: {
      weight: 5, //Minor Prophets
      chapters: 4,
      verses: [
        17, 10, 10, 11,
      ],
    },

    Micah: {
      weight: 5, //Minor Prophets
      chapters: 7,
      verses: [
        16, 13, 12, 13, 15, 16, 20,
      ],
      breaks: { 1: [7], 6: [8], 7: [7, 13] },
    },

    Nahum: {
      weight: 5, //Minor Prophets
      chapters: 3,
      verses: [
        15, 13, 19,
      ],
    },

    Habakkuk: {
      weight: 5, //Minor Prophets
      chapters: 3,
      verses: [
        17, 20, 19,
      ],
      breaks: { 1: [11] },
    },
    Zephaniah: {
      weight: 5, //Minor Prophets
      chapters: 3,
      verses: [
        18, 15, 20,
      ],
      breaks: { 1: [13], 2: [7, 12] },
    },
    Haggai: {
      weight: 5, //Minor Prophets
      chapters: 2,
      verses: [
        15, 23,
      ],
      breaks: { 2: [9] },
    },
    Zechariah: {
      weight: 5, //Minor Prophets
      chapters: 14,
      verses: [
        21, 13, 10, 14, 11, 15, 14, 23, 17, 12, 17, 14, 9, 21,
      ],
      breaks: { 6: [8], 9: [8, 13], 12: [9], 13: [6] },
    },

    Malachi: {
      weight: 5, //Minor Prophets
      chapters: 4,
      verses: [
        14, 17, 18, 6,
      ],
      breaks: { 1: [5], 2: [9], 3: [5] },
    },

    Matthew: {
      weight: 6, //Gosple
      chapters: 28,
      verses: [
        25, 23, 17, 25, 48, 34, 29, 34, 38, 42, 30, 50, 58, 36, 39, 28, 27, 35,
        30, 34, 46, 46, 39, 51, 46, 75, 66, 20,
      ],
      breaks: {
        1: [17],
        2: [12, 18],
        3: [12],
        4: [11, 17, 22],
        5: [12, 16, 20, 26, 30, 32, 37, 42],
        6: [4, 15, 18, 24],
        7: [6, 12, 14, 23],
        8: [4, 13, 17, 22, 27],
        9: [8, 13, 17, 26, 34],
        11: [19, 24],
        12: [14, 21, 37, 45],
        13: [23, 30, 35, 43, 46, 52],
        14: [12, 21],
        15: [20, 28],
        16: [4, 12, 20],
        17: [13, 23],
        18: [9, 14, 20],
        19: [12, 15],
        20: [16, 19, 28],
        21: [11, 17, 22, 27, 32],
        22: [14, 22, 33, 40],
        24: [35],
        25: [13, 30],
        26: [5, 13, 16, 30, 35, 46, 56, 68],
        27: [10, 26, 31, 44, 56, 61],
        28: [10, 15],
      },
    },

    Mark: {
      weight: 6, //Gosple
      chapters: 16,
      verses: [
        45, 28, 35, 41, 43, 56, 37, 38, 50, 52, 33, 44, 37, 72, 47, 20,
      ],
      breaks: {
        1: [8, 13, 20, 28, 34, 39],
        2: [12, 17, 22],
        3: [12, 19, 30],
        4: [12, 20, 25, 29, 34],
        5: [20],
        6: [5, 13, 29, 44],
        7: [23, 30],
        8: [13, 21, 26, 30],
        9: [13, 32, 37, 41],
        10: [12, 16, 31, 34, 45],
        11: [11, 19, 26],
        12: [12, 17, 27, 34, 40],
        13: [31],
        14: [11, 26, 31, 42, 52, 65],
        15: [15, 20, 32, 41],
        16: [8],
      },
    },
    Luke: {
      weight: 6, //Gosple
      chapters: 24,
      verses: [
        80, 52, 38, 44, 39, 49, 50, 56, 62, 42, 54, 59, 35, 35, 32, 31, 37, 43,
        48, 47, 38, 71, 56, 53,
      ],
      breaks: {
        1: [4, 25, 38, 45, 56, 66],
        2: [7, 20, 40],
        3: [20],
        4: [13, 30, 37],
        5: [11, 16, 26, 32],
        6: [11, 16, 26, 36, 42, 45],
        7: [10, 17, 35],
        8: [15, 18, 21, 25, 39],
        9: [9, 17, 27, 36, 45, 50, 56],
        10: [24, 37],
        11: [13, 28, 32, 36],
        12: [12, 21, 34, 48, 53],
        13: [9, 17, 21, 30],
        14: [14, 24],
        15: [7, 10],
        16: [15, 18],
        17: [10, 19],
        18: [8, 14, 17, 30, 34],
        19: [10, 27, 44],
        20: [8, 19, 26, 40],
        21: [4],
        22: [6, 38, 46, 53, 65],
        23: [25, 43, 49],
        24: [12, 35, 49],
      },
    },
    John: {
      weight: 6, //Gosple
      chapters: 21,
      verses: [
        51, 25, 36, 54, 47, 71, 53, 59, 41, 42, 57, 50, 38, 31, 27, 33, 26, 40,
        42, 31, 25,
      ],
      breaks: {
        1: [18, 28, 34, 42],
        2: [11],
        3: [21],
        4: [26, 38, 42],
        5: [15, 30],
        6: [15, 24, 59],
        7: [13, 24, 44],
        8: [11, 30, 41, 47],
        9: [12, 34],
        10: [21],
        11: [16, 37, 44],
        12: [11, 19, 36],
        13: [17, 30],
        14: [4, 14],
        15: [17],
        16: [4, 16],
        17: [5, 19],
        18: [11, 14, 18, 24, 27],
        19: [16, 27, 37],
        20: [9, 18, 23],
        21: [14],
      },
    },
    Acts: {
      weight: 7, //Acts
      chapters: 28,
      verses: [
        26, 47, 26, 37, 42, 15, 60, 40, 43, 48, 30, 25, 52, 28, 41, 40, 34, 28,
        41, 38, 40, 30, 35, 27, 27, 32, 44, 31,
      ],
      breaks: {
        1: [11],
        2: [13, 41],
        3: [10],
        4: [22, 31],
        5: [11, 16],
        6: [7],
        7: [53],
        8: [3, 8, 25],
        9: [19, 31],
        10: [8, 22],
        11: [18],
        12: [18],
        13: [3, 12],
        14: [20],
        15: [21, 35],
        16: [5, 10, 15],
        17: [9, 15],
        18: [17],
        19: [22],
        20: [6, 12],
        21: [16, 26, 36],
        22: [21, 29],
        23: [11, 22],
        25: [12, 22],
        27: [12, 26],
        28: [10, 16],
      },
    },
    Romans: {
      weight: 8, //Pauline Epistle
      chapters: 16,
      verses: [
        32, 29, 31, 25, 21, 23, 25, 39, 33, 21, 36, 21, 14, 23, 33, 27,
      ],
      breaks: {
        1: [7, 17],
        2: [16],
        3: [8, 20],
        4: [15],
        5: [11],
        6: [14],
        7: [6],
        8: [17, 27],
        9: [29],
        10: [15],
        11: [10, 24, 32],
        12: [8],
        13: [7],
        15: [13, 22],
      },
    },
    "1 Corinthians": {
      weight: 8, //Pauline Epistle
      chapters: 16,
      verses: [
        31, 16, 23, 21, 13, 20, 40, 13, 27, 33, 34, 31, 13, 40, 58, 24,
      ],
      breaks: {
        1: [3, 9, 17],
        2: [5],
        6: [11],
        10: [13, 22],
        11: [16],
        12: [11],
        14: [25],
        15: [11, 34],
        16: [4, 18],
      },
    },
    "2 Corinthians": {
      weight: 8, //Pauline Epistle
      chapters: 13,
      verses: [
        24, 17, 18, 18, 21, 18, 16, 24, 15, 18, 33, 21, 14,
      ],
      breaks: {
        1: [2, 11],
        2: [4, 11],
        3: [6],
        5: [10],
        6: [2, 13],
        8: [15],
        9: [5],
        11: [15],
        12: [10],
        13: [10],
      },
    },
    Galatians: {
      weight: 8, //Pauline Epistle
      chapters: 6,
      verses: [
        24, 21, 29, 31, 26, 18,
      ],
      breaks: {
        1: [5, 10],
        2: [10],
        3: [14, 25],
        4: [7, 20],
        5: [15],
        6: [10],
      },
    },

    Ephesians: {
      weight: 8, //Pauline Epistle
      chapters: 6,
      verses: [
        23, 22, 21, 32, 33, 24,
      ],
      breaKS: { 1: [2, 14], 2: [10], 3: [13], 4: [16], 5: [21], 6: [4, 9] },
    },

    Philippians: {
      weight: 8, //Pauline Epistle
      chapters: 4,
      verses: [
        30, 30, 21, 23,
      ],
      breaks: { 1: [2, 11], 2: [11, 18], 3: [11], 4: [1, 9, 20] },
    },

    Colossians: {
      weight: 8, //Pauline Epistle
      chapters: 4,
      verses: [
        29, 23, 25, 18,
      ],
      breaks: { 1: [2, 14, 23], 2: [5], 3: [17], 4: [1, 8] },
    },

    "1 Thessalonians": {
      weight: 8, //Pauline Epistle
      chapters: 5,
      verses: [
        10, 20, 13, 18, 28,
      ],
      breaks: { 1: [1], 2: [16], 3: [5], 4: [12], 5: [11] },
    },

    "2 Thessalonians": {
      weight: 8, //Pauline Epistle
      chapters: 3,
      verses: [
        12, 17, 18,
      ],
      breaks: { 1: [2], 2: [12], 3: [5, 15] },
    },

    "1 Timothy": {
      weight: 8, //Pauline Epistle
      chapters: 6,
      verses: [
        20, 15, 16, 16, 25, 21,
      ],
      breaks: { 1: [2, 11], 6: [2, 10] },
    },

    "2 Timothy": {
      weight: 8, //Pauline Epistle
      chapters: 4,
      verses: [
        18, 26, 17, 22,
      ],
      breaks: { 1: [2], 2: [13], 3: [9], 4: [8, 18] },
    },

    Titus: {
      weight: 8, //Pauline Epistle
      chapters: 3,
      verses: [
        16, 15, 15,
      ],
      breaks: { 1: [4], 3: [11] },
    },

    Philemon: {
      weight: 8, //Pauline Epistle
      chapters: 1,
      verses: [
        25,
      ],
      breaks: { 1: [4, 8] },
    },

    Hebrews: {
      weight: 9, //General Epistle
      chapters: 13,
      verses: [
        14, 18, 19, 16, 14, 20, 28, 13, 28, 39, 40, 29, 25,
      ],
      breaks: {
        2: [4],
        3: [6],
        4: [13],
        5: [10],
        6: [12],
        7: [10],
        9: [10],
        10: [18],
        12: [13],
      },
    },

    James: {
      weight: 9, //General Epistle
      chapters: 5,
      verses: [
        27, 26, 18, 17, 20,
      ],
      breaks: { 1: [18], 2: [13], 3: [12], 4: [12], 5: [6, 12] },
    },

    "1 Peter": {
      weight: 9, //General Epistle
      chapters: 5,
      verses: [
        25, 25, 22, 19, 14,
      ],
      breaks: { 1: [2, 12], 2: [3, 12], 3: [7], 4: [11], 5: [11] },
    },

    "2 Peter": {
      weight: 9, //General Epistle
      chapters: 3,
      verses: [
        21, 22, 18,
      ],
      breaks: { 1: [2, 11] },
    },

    "1 John": {
      weight: 9, //General Epistle
      chapters: 5,
      verses: [
        10, 29, 24, 21, 21,
      ],
      breaks: { 1: [4], 2: [14, 17, 27], 3: [10], 4: [6], 5: [12] },
    },

    "2 John": {
      weight: 9, //General Epistle
      chapters: 1,
      verses: [
        13,
      ],
    },

    "3 John": {
      weight: 9, //General Epistle
      chapters: 1,
      verses: [
        14,
      ],
    },

    Jude: {
      weight: 9, //General Epistle
      chapters: 1,
      verses: [
        25,
      ],
      breaks: { 1: [2, 16, 23] },
    },

    Revelation: {
      weight: 12, //Revelation
      chapters: 22,
      verses: [
        20, 29, 22, 11, 14, 17, 17, 13, 21, 11, 19, 17, 18, 20, 8, 21, 18, 24,
        21, 15, 27, 21,
      ],
      breaks: {
        1: [3, 8],
        2: [7, 11, 17],
        3: [6, 13],
        7: [8],
        8: [5],
        11: [14],
        13: [10],
        14: [5, 13],
        19: [10],
        20: [6, 10],
        22: [6],
      },
    },
  }
